import React from 'react';
import '../SCSS/Loader.scss';

const Loader: React.FC = () => (
  <div className="overlay">
    <div className="loader">
      <div className="spinner"></div>
    </div>
  </div>
);

export default Loader;